import { Component, ContentChild, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { EditorContentDirective } from '../editors/directives/editor-content.directive';
import { NbMenuItem, NbSidebarService } from '@nebular/theme';
import { DynamicInputComponent, MenuGroup } from '../editors/dynamic-input-model';
import { SideBarDockingService } from '../services/side-bar-docking.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kv-editor-container',
  templateUrl: './editor-container.component.html',
  styleUrls: ['./editor-container.component.scss']
})
/**
 * Inputs
 * 1. menuItems: NbMenuItem[] -
 */
export class EditorContainerComponent implements OnInit, OnDestroy {
  @Input() menuItems: NbMenuItem[];
  @Input() title: string;
  @Input() menuTag: string;
  @Input() inputComponent: DynamicInputComponent;
  @Input() menuGroups: MenuGroup[];
  @Input() status: string;
  @Input() canSave: boolean = false

  isCompacted: boolean = false;
  state: string;
  sideBarSubscription: Subscription;

  private destroy$ = new Subject<void>();

  // @Output() toggleSideBarRight = new EventEmitter<string>();

  // @ContentChild(EditorContentDirective) content!: EditorContentDirective;

  constructor(
    private el: ElementRef,
    private sideBarDockingService: SideBarDockingService,
    private sideBarService: NbSidebarService) {
    this.sideBarSubscription = this.sideBarService.getSidebarState("right")
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        // console.log(state)
        /* if(sideBar.tag == "right"){
          console.log("It's true")
          this.isCompacted = true;
        } */
      })
  }

  ngOnInit(): void {
    // this.sideBarService.getSidebarState("right").
    this.sideBarSubscription = this.sideBarService.getSidebarState("right")
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        // console.log(state)
        /* if(sideBar.tag == "right"){
          console.log("It's true")
          this.isCompacted = true;
        } */
      })
    this.sideBarService.onCompact().subscribe(tag => {
      // console.log(tag.tag)
    })
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    const host = <HTMLElement>this.el.nativeElement;
    host.style.setProperty('--menu-item-divider-color', '#5e5e5f');
    host.style.setProperty('--menu-item-padding', '0 1rem');
    // host.style.setProperty('--menu-background-color','#ccc');
    /* let menuItemCollections = host.getElementsByTagName("LI");
    for(let i=0;i<menuItemCollections.length;i++){
      let anchorElement = <HTMLElement>menuItemCollections[i].children[0];
      anchorElement.style.setProperty('display','unset');
    } */

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    if (changes["inputComponent"]) {
      // console.log(this.inputComponent);
    }
    if (changes["canSave"]) {
      console.log(this.canSave);
    }
  }

  toggleSideBar(e) {
    // console.log("Toggle icon clicked");
    // this.toggleSideBarRight.emit('rightSideBar');
    this.sideBarDockingService.emitSideBarToggled('rightSideBar');
    this.sideBarService.getSidebarState("right").subscribe(state => {
      this.state = state;
    });
  }

  onSave() {
    // console.log("Save clicked");
  }

  onPublish() {
    // console.log("Publish clicked");
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
